type Props = Readonly<{
  value: number;
  colored?: boolean;
}>;

export function Percent({ value, colored = true }: Props): JSX.Element {
  const color = value >= 0 ? "text-green-500" : "text-red-500";
  return <span className={colored ? color : ""}>{value.toFixed(2)}%</span>;
}
